import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;

  height: fit-content;

  padding: 10px 20px;
  gap: 10px;

  @media only screen and (max-width: 600px) {
    align-items: start;
    flex-direction: column;
  }
`;

export const Title = styled.span`
  font-size: 1.5rem;

  a {
    padding: unset;

    &:before {
      position: unset;
      border: unset;
      content: none;
    }
  }
`;

type LinksProps = {
  $visible: boolean;
};

export const Links = styled.div<LinksProps>`
  display: inline-flex;
  gap: 10px;

  @media only screen and (max-width: 600px) {
    display: ${({ $visible }) => ($visible ? 'inline-flex' : 'none')};
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
`;

export const LinkSection = styled.div`
  display: inline-flex;
  justify-items: right;
  font-size: 1.5rem;
  cursor: default;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const MenuLink = styled(Link)`
  position: relative;
  padding: 0 20px;
  color: inherit;
  text-decoration: underline 0.1rem rgba(0, 0, 0, 0);
  text-underline-offset: 0.1em;
  transition:
    text-decoration-color 150ms,
    text-underline-offset 150ms,
    color 150ms;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colours.accent};
    text-decoration-color: ${({ theme }) => theme.colours.accent};
    text-underline-offset: 0.3em;
  }

  &:before {
    position: absolute;
    left: 0;
    bottom: 25%;
    border-left: 4px solid ${({ theme }) => theme.colours.accent};
    height: 50%;
    content: '';
  }

  @media only screen and (max-width: 600px) {
    padding: 10px 0;
    text-decoration: unset;

    &:before {
      left: 25%;
      bottom: 0;
      border-left: unset;
      border-bottom: 2px solid ${({ theme }) => theme.colours.accent};
      height: unset;
      width: 50%;
    }
  }
`;

export const ToggleButton = styled.button`
  display: none;
  font-size: 2rem;
  background: unset;
  border: 2px solid ${({ theme }) => theme.colours.accent};
  border-radius: 4px;
  color: ${({ theme }) => theme.colours.fg};
  cursor: pointer;
  transition: color 150ms;

  &:hover {
    color: ${({ theme }) => theme.colours.accent};
  }

  @media only screen and (max-width: 600px) {
    display: flex;
    justify-content: center;
    position: absolute;
    right: 1.5rem;
    top: 1rem;
  }
`;
